export const AUDIT_RULE_CATEGORY_SELECT_CHANGED = 'onAuditRuleCategorySelectChanged'



// WEBPACK FOOTER //
// ./src/views/09System-Settings/04Config/05Auto-Audit-Rule/EventKeys.js